import { Component } from '@angular/core';
import { NavParams, ViewController } from 'ionic-angular';

@Component({
	selector: 'popover-feed-component',
	templateUrl: 'popover-feed.html'
})
export class PopoverFeedComponent {
	constructor(private viewCtrl: ViewController, private navParams: NavParams) {

	}

	onEntrySelect(entry) {
		this.viewCtrl.dismiss(entry);
	}
}



// WEBPACK FOOTER //
// /src/components/popover-feed/popover-feed.ts